import { render } from "./ArticleBuild.vue?vue&type=template&id=039c09ad"
import script from "./ArticleBuild.vue?vue&type=script&lang=js"
export * from "./ArticleBuild.vue?vue&type=script&lang=js"

import "./ArticleBuild.vue?vue&type=style&index=0&id=039c09ad&lang=sass"

import exportComponent from "/var/www/happycab/prod/hc-core/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';
import QBreadcrumbsEl from 'quasar/src/components/breadcrumbs/QBreadcrumbsEl.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBreadcrumbs,QBreadcrumbsEl,QChip,QImg,QBtn,QCard,QCardSection,QInput,QAvatar,QDialog});
